import { writable } from 'svelte/store';
import * as easing from 'svelte/easing';
import * as transitions from './transitions';
import { typeValues } from './LoremIpsum.svelte';

const firstTransition = Object.keys(transitions)[0];

export const inTransitionValues = writable({
		transitionDuration: 1000,
		easingName: 'linear',
		transitionName:firstTransition,
});
	
export const outTransitionValues = writable({
	transitionDuration: 1000,
	easingName: 'linear',		
	transitionName: firstTransition,
});

export const controls = writable({
	on: true,
	loremIpsumType: typeValues[0],
});
	